import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import useLegacySafariWarningModal from '../Hooks/useLegacySafariWarningModal';

const SafariWarningModal = () => {
  const [showWarning, setShowWarning] = useLegacySafariWarningModal();

  const handleOpenChrome = () => {
    window.open('https://www.google.com/chrome/', '_blank');
  };

  return (
    <Dialog
      header="Navegador desatualizado"
      visible={showWarning}
      closable={true}
      modal
      style={{ width: '90vw', maxWidth: '500px' }}
      onHide={() => setShowWarning(false)}
    >
      <p>
        Detectamos que você está usando uma versão antiga do Safari no iOS ou macOS.
        Algumas funcionalidades do nosso aplicativo podem não funcionar corretamente.
      </p>
      <p>
        Para uma melhor experiência, recomendamos atualizar seu sistema ou utilizar o navegador
        Google Chrome.
      </p>

      <div className="flex justify-content-end" style={{ marginTop: '2rem' }}>
        <Button
          label="Abrir no Chrome"
          icon="pi pi-external-link"
          onClick={handleOpenChrome}
          className="p-button-outlined"
        />
      </div>
    </Dialog>
  );
};

export default SafariWarningModal;
